function containsOnlyNumbers(str: string) {
	return /^\d+$/.test(str);
}

export function getIframeWidth(
	width?: string | number,
	elWidth?: string | number
) {
	if (!width && !elWidth) {
		return 'auto';
	}

	const PADDING = 30;

	if (width) {
		return typeof width === 'number' || containsOnlyNumbers(width)
			? `calc(${width}px + ${PADDING * 2}px)`
			: `calc(${width} + ${PADDING * 2}px)`;
	}

	return `calc(${elWidth}px + ${PADDING * 2}px)`;
}
